import { useEffect, useState } from 'react'
import s from './styles.module.scss'
import { Link } from 'react-router-dom'
import { Data8Service } from '../../../services'

interface inputFieldTextProps {
    fieldName: string
    saveValue: (obj: { field: string; value: string }) => { success: boolean; error: string }
    submitValue?: any
    fieldType?: string | null
    populateValue?: string
    enhanced?: boolean
    required?: boolean
    showErrors?: boolean
}

export const InputFieldText = (props: inputFieldTextProps) => {
    const {
        fieldName,
        saveValue,
        fieldType,
        populateValue,
        enhanced = false,
        required = false,
        showErrors = false,
    } = props
    const [valueToSave, setValueToSave] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        if (!valueToSave && typeof populateValue != 'undefined' && populateValue !== '') {
            setValueToSave(populateValue)
        }
    }, [populateValue])

    useEffect(() => {
        if (showErrors && required && !valueToSave.trim()) {
            setError('This field is required')
        } else {
            setError('')
        }
    }, [showErrors, required, valueToSave])

    const onChangeFunc = async (e: React.ChangeEvent<HTMLInputElement>) => {
        let newValue = e.currentTarget.value
        setValueToSave(newValue)

        let toSave = { field: fieldName, value: newValue }
        const isValid = await data8Validation(newValue)

        if (!isValid) toSave.value = ''
        const saveResult = saveValue(toSave)

        saveResult.success ? setError('') : setError(saveResult.error)
    }

    const data8Validation = async (newValue: string) => {
        if (typeof fieldType != 'undefined' && fieldType == 'email' && newValue.length > 0) {
            const data8Valid = await Data8Service('EmailValidation', 'IsValid', { email: newValue })
            if (data8Valid.Result === 'Invalid') {
                setError('Invalid email')
                return false
            }
        }
        if (typeof fieldType != 'undefined' && fieldType == 'tel' && newValue.length > 0) {
            const data8Valid = await Data8Service('PhoneValidation', 'IsValid', {
                telephoneNumber: newValue,
                defaultCountry: 'GB',
            })
            if (data8Valid.Result.ValidationResult === 'Invalid') {
                setError('Invalid telephone number')
                return false
            }
        }
        return true
    }

    return (
        <>
            <div className={s.inputWrapper}>
                <input
                    className={`${s.inputStyle} ${fieldName == 'registration' ? s.uppercase : ''} ${
                        enhanced ? s.enhanced : ''
                    } ${error ? s.error : ''}`}
                    type={`${fieldType != null ? fieldType : 'text'}`}
                    name={fieldName}
                    value={valueToSave}
                    onChange={onChangeFunc}
                    required={required}
                />
            </div>
            {error && <span className={s.notice}>{error}</span>}
        </>
    )
}
